import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withPagination } from "@ngneat/elf-pagination";
import { withRequestsStatus } from "@ngneat/elf-requests";

import { ClientModel } from "@store/entities/clients/clients.model";

export const clientsStore = createStore({ name: "clients" }, withEntities<ClientModel>(), withRequestsStatus(), withPagination());
